module.exports = __webpack_public_path__ + "iux-wx.jpg?988cd80313dd4d982333e32a5737437b";


//////////////////
// WEBPACK FOOTER
// ./static/images/iux-wx.jpg
// module id = 389
// module chunks = 0